import React, { useState, useEffect } from 'react';
import { api } from '../App';
import '../styles/BestellingenOverzichtPage.css';
import PageLoader from '../components/PageLoader';
import BestellingDatumOverzicht from '../components/BestellingDatumOverzicht';

function BestellingenOverzichtPage({ user, onBack, onLogout, onSelectOrder, onNewOrder }) {
  const [groepen, setGroepen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const fetchOverzicht = async () => {
      try {
        const response = await api.get('/index.php?action=mybestellingoverzicht');
        if (cancelled) return;
        setGroepen(response.data);
        setLoading(false);
      } catch (err) {
        if (cancelled) return;
        setError('Fout bij laden van bestellingen');
        setLoading(false);
      }
    };

    fetchOverzicht();
    return () => {
      cancelled = true;
    };
  }, []);

  const totaalBestellingen = groepen.reduce(
    (sum, groep) => sum + groep.bestellingen.length,
    0
  );

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="bestellingen-overzicht-container">
      <header className="bestelling-header">
        <button onClick={onBack} className="back-button">← Terug</button>
        <h1>Mijn Bestellingen</h1>
        <button onClick={onLogout} className="logout-button">Uitloggen</button>
      </header>

      <main className="bestelling-main">
        <div className="bestellingen-content">
          {error && <div className="error-message">{error}</div>}

          {totaalBestellingen === 0 ? (
            <div className="no-orders">
              <p>Je hebt nog geen bestellingen geplaatst.</p>
              <button onClick={onNewOrder} className="primary-button">
                Plaats je eerste bestelling
              </button>
            </div>
          ) : (
            <>
              <p className="overzicht-intro">
                Overzicht per leveringsdatum — in één oogopslag wat je hebt besteld.
              </p>
              <BestellingDatumOverzicht
                groepen={groepen}
                onSelectOrder={onSelectOrder}
              />
              <div className="overzicht-new-order">
                <button onClick={onNewOrder} className="primary-button">
                  Nieuwe bestelling plaatsen
                </button>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export default BestellingenOverzichtPage;
